const OPTIONS = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "last7", label: "Last 7d" },
  { value: "last30", label: "Last 30d" },
  { value: "custom", label: "Custom" }
];

export default function TimeFilter({ value, onChange }) {
  const activeIndex = Math.max(
    0,
    OPTIONS.findIndex((o) => o.value === value)
  );

  return (
    <div
      className="segmented"
      role="tablist"
      aria-label="Time range"
      style={{ "--count": OPTIONS.length, "--i": activeIndex }}
    >
      <div className="segmented-indicator" aria-hidden="true" />
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={value === o.value}
          className={`segmented-option${value === o.value ? " active" : ""}`}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
